export const formatBigNumbers = (number) =>{
  let num = number.toString();
  return num.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
}

export const firstDayInCurrentMonth = (todayDate) =>{
    return new Date(todayDate.getFullYear(), todayDate.getMonth(), 1);
}
export const firstDayInPreviousMonth = (todayDate) =>{
    return new Date(todayDate.getFullYear(), todayDate.getMonth() - 1, 1);
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const getMonthName = (monthNumber) =>{
  return monthNames[monthNumber];
}
export const getMonthShortName = (monthNumber) =>{
  return monthShortNames[monthNumber];
}


export const isInputDateSupported = () =>{
  const input = document.createElement('input');
  const value = 'a';
  input.setAttribute('type', 'date');
  input.setAttribute('value', value);
  return (input.value !== value);
}

export const isFirefox = () =>{
  if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
    return true;
  } else {
    return false;
  }
}

export const redirectTo = (props, path) => {
  props.history.push(path);
}



// WEBPACK FOOTER //
// ./src/Helpers.js